import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { ref, withDefaults, watch, computed, onMounted } from 'vue';
import { themeIcons } from "seti-icons";

export interface PropsOptions {
	filename: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FileIcon',
  props: {
    filename: { default() {
		return "";
	} }
  },
  setup(__props: any) {

const props = __props as { filename: string }




const getIcon = themeIcons({
	'white': "#d4d7d6",
	'grey': "#4d5a5e",
	'grey-light': "#6d8086",
	'blue': "#519aba",
	'green': "#8dc149",
	'orange': "#e37933",
	'pink': "#f55385",
	'purple': "#a074c4",
	'red': "#cc3e44",
	'yellow': "#cbcb41",
	'ignore': "#41535b",
})

const icon = ref<any|null>(null);

const svg = computed((): string => {
	if (icon.value == null) {
		return "";
	}
	return icon.value.svg;
});

const color = computed((): string => {
	if (icon.value == null) {
		return "";
	}
	return icon.value.color;
});

function loadIcon() {
	icon.value = getIcon(props.filename);
	//console.log({icon: icon.value});
}

watch(() => props.filename, () => {
	loadIcon();
});

onMounted(() => {
	loadIcon();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    innerHTML: _unref(svg),
    style: _normalizeStyle({fill: _unref(color)})
  }, null, 12, _hoisted_1))
}
}

})